<template>
  <div class="marketing-email-editor-html">
    <div class="marketing-email-editor-html-editor">
      <code-editor class="marketing-email-editor-html-editor-code"
                   :value="value"
                   :languages="defaultLang"
                   :wrap_code="true"
                   font_size="12px"
                   @input="emitInput"></code-editor>
    </div>

    <div class="marketing-email-editor-html-preview">
      <div class="marketing-email-editor-html-preview-header">
        <app-button :label="$t('message.generics.message.settings')"
                    small
                    flat
                    @click="emitConfig"></app-button>
      </div>
      <div class="marketing-email-editor-html-preview-content"
           v-html="value"></div>
    </div>
  </div>
</template>

<script>
import AppButton from "@/components/generic/button/Button";
import CodeEditor from "simple-code-editor";
import EventBus from "../../../../../../packages/event-bus";

export default {
  components: {
    CodeEditor,
    AppButton,
  },

  props: {
    value: {
      type: String,
      default: `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Document</title>
      </head>
      <body>

      </body>
      </html>
      `,
    },
  },

  data() {
    return {
      defaultLang: [["html", "HTML"]],
    };
  },

  computed: {},

  mounted() {
    this.setCopyContentFunction()
  },  

  methods: {
    emitInput(val) {      
      this.$emit("input", val);
    },
    emitConfig() {
      this.$emit("config");
    },
    setCopyContentFunction() {
      const copyCodeDiv = document.querySelector('.copy_code')
      copyCodeDiv.addEventListener('click', this.copyContent)
    },
    copyContent() {
      if(this.value) {
        navigator.clipboard.writeText(this.value)          
          .catch(() => {
            EventBus.$emit('show-message', {
              type: 'ERROR',
              message: this.$t('message.errorMessages.message.copyCode')
            })
          })
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-email-editor-html {
  display: flex;
  max-width: calc(100vw - 300px);

  .marketing-email-editor-html-preview {
    flex: 1.2;
    max-height: 600px;
    overflow-y: scroll;
    border: 1px solid rgba($grey-4, 0.27);

    .marketing-email-editor-html-preview-header {
      margin: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid rgba($grey-4, 0.27);
    }

    .marketing-email-editor-html-preview-content {
      display: flex;
      justify-content: center;
    }
  }

  .marketing-email-editor-html-editor {
    flex: 1;
    max-height: 600px;
    overflow-y: scroll;
    border: 1px solid rgba($grey-4, 0.27);

    .marketing-email-editor-html-editor-code {
      width: auto !important;
      border-radius: 0 !important;

      ::v-deep .code_area {
        overflow-y: scroll;
      }
      ::v-deep .tooltip {
        padding: 0;
      }
    }
  }
}
</style>

